import { FormattedMessage } from 'react-intl';
import DefaultLayout from '../../Layout/DefaultLayout';

export default function AboutPage() {
  return <DefaultLayout><h1><FormattedMessage id="ABOUT" /></h1></DefaultLayout>;
}
